/**
 * Every user-visible brand string and colour lives here so a rename is a one-file change.
 */
export const BRAND = {
  name: 'One Night Ultimate Werewolf',
  shortName: 'ONUW',
  tagline: 'One night. One vote. Trust no one.',
  /** Production origin; overridden by VITE_SITE_ORIGIN at build time. */
  siteOrigin: 'https://onuw-online.com',
  themeColor: '#1c1700',
  backgroundColor: '#1c1700',
  adsensePublisherId: 'pub-5207665938843420',
  /** This site's own GA4 property (not the old app's). */
  ga4MeasurementId: 'G-BVFK0DP6T5',
  /** Buy Me a Coffee page, linked from the foot of the home page. */
  coffeeUrl: 'https://buymeacoffee.com/vpricadpe',
} as const
